var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { I18nService } from '@app/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@app/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '@app/user.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
var MainmenuComponent = /** @class */ (function () {
    function MainmenuComponent(i18nService, titleService, Auth, router, user, util, apiService) {
        var _this = this;
        this.i18nService = i18nService;
        this.titleService = titleService;
        this.Auth = Auth;
        this.router = router;
        this.user = user;
        this.util = util;
        this.apiService = apiService;
        router.events.subscribe(function (val) {
            if (val instanceof NavigationEnd) {
                _this.SelectMenu(val.url);
            }
        });
    }
    MainmenuComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        document.body.className = 'sidebar-mini accent-danger';
                        this.VerifyRole();
                        $('[data-provide="datepicker"]').attr('placeholder', 'DD/MM/YYYY');
                        $(".user-menu").on("click", function () {
                            thisTs.router.navigate(["/mainmenu/" + this.id]);
                        });
                        return [4 /*yield*/, this.CallApi()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.CallApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, forkJoin([
                        this.InitDropdownItems()
                    ])];
            });
        });
    };
    MainmenuComponent.prototype.InitDropdownItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        if (!(localStorage.getItem("companyType") == null)) return [3 /*break*/, 2];
                        _b = (_a = localStorage).setItem;
                        _c = ["companyType"];
                        _e = (_d = JSON).stringify;
                        return [4 /*yield*/, this.apiService.get("master", "companyType")];
                    case 1:
                        _b.apply(_a, _c.concat([_e.apply(_d, [_r.sent()])]));
                        _r.label = 2;
                    case 2:
                        if (!(localStorage.getItem("personalType") == null)) return [3 /*break*/, 4];
                        _g = (_f = localStorage).setItem;
                        _h = ["personalType"];
                        _k = (_j = JSON).stringify;
                        return [4 /*yield*/, this.apiService.get("master", "personalType")];
                    case 3:
                        _g.apply(_f, _h.concat([_k.apply(_j, [_r.sent()])]));
                        _r.label = 4;
                    case 4:
                        if (!(localStorage.getItem("address") == null)) return [3 /*break*/, 6];
                        _m = (_l = localStorage).setItem;
                        _o = ["address"];
                        _q = (_p = JSON).stringify;
                        return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 5:
                        _m.apply(_l, _o.concat([_q.apply(_p, [_r.sent()])]));
                        _r.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.SelectMenu = function (Url) {
        this.ActivatedComponent = Url.substring(Url.lastIndexOf('/') + 1, Url.length);
        switch (this.ActivatedComponent) {
            case "ticketlist": {
                $('#ticketlist').addClass("active");
                $('#register').removeClass("active");
                $('#profile').removeClass("active");
                $('#prereqdocument').removeClass("active");
                break;
            }
            case "register": {
                $('#ticketlist').removeClass("active");
                $('#register').addClass("active");
                $('#profile').removeClass("active");
                $('#prereqdocument').removeClass("active");
                break;
            }
            case "profile": {
                $('#ticketlist').removeClass("active");
                $('#register').removeClass("active");
                $('#profile').addClass("active");
                $('#prereqdocument').removeClass("active");
                break;
            }
            case "prereqdocument": {
                $('#ticketlist').removeClass("active");
                $('#register').removeClass("active");
                $('#profile').removeClass("active");
                $('#prereqdocument').addClass("active");
                break;
            }
            default: break;
        }
    };
    MainmenuComponent.prototype.VerifyRole = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, Profile, Role;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.Auth.CheckSessionState())
                            return [2 /*return*/];
                        thisTs = this;
                        return [4 /*yield*/, this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile"))];
                    case 1:
                        Profile = _a.sent();
                        return [4 /*yield*/, this.Auth.GetRole(Profile[0]["dpa_roleid"])];
                    case 2:
                        Role = _a.sent();
                        if (Role[0]["dpa_access_ticketlist"] == false) {
                            $('#MenuTicketList').addClass("hidden");
                        }
                        if (Role[0]["dpa_access_register"] == false) {
                            $('#MenuRegister').addClass("hidden");
                        }
                        if (Role[0]["dpa_access_profile"] == false) {
                            $('#MenuProfile').addClass("hidden");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.Logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem("AgentBank_Profile");
                this.Auth.setLoggedIn(false);
                this.router.navigate(['login']);
                return [2 /*return*/];
            });
        });
    };
    MainmenuComponent.prototype.ClaerActiveTabMenu = function () {
        $(".user-menu").each(function () {
            $(this).prop("aria-selected", false);
            $(this).removeClass("active");
        });
    };
    return MainmenuComponent;
}());
export { MainmenuComponent };



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts.pre-build-optimizer.js